import { UserTypes } from '@commenda/types/src/chat-room';
import { IMeeting } from '@commenda/types/src/meeting/types';

export class MeetingModel {
  static MEETING_LINKS = {
    BOOK_A_CALL_DEMO: 'https://www.commenda.io/book-a-demo',
    DOBUSINESS: 'https://cal.com/dobusiness/15min',
    CONSULTATION:
      'https://meetings.hubspot.com/sandeep-bhat/website-consultation-with-commenda',
    CONSULTATION_AFTER_24_HOUR:
      'https://meetings.hubspot.com/sandeep-bhat/meeting-with-commenda',
    INCORPORATION_WIZARD_BOOK_A_CALL:
      'https://meetings.hubspot.com/spencer318/consultation-with-commenda',
    OTHER_BOOK_A_CALL_INCORPORATION_WIZARD:
      'https://meetings.hubspot.com/spencer318/consultation-with-commenda',
    LOGAN_JACKONIS: 'https://cal.com/loganjackonis/30min',
    HUBSPOT_BOOK_A_CALL_URL:
      'https://meetings-na2.hubspot.com/spencer318/consultation-with-commenda',
  };

  static getMeetingURLPath(meeting: IMeeting) {
    if (!meeting) {
      console.error('Meeting is undefined in getMeetingURLPath');
      return null;
    }
    return `/calendar/accountant/${meeting.bookedWithUser.calComUserName}/event/internal-meetings?meetingId=${meeting.id}&slug=${meeting.sourceEventTypeSlug}`;
  }

  static filterPastMeetings(meetings: IMeeting[], userType: UserTypes) {
    if (!meetings) return [];
    const filteredMeetings = meetings.filter((meeting) => {
      // Admin can see all meetings
      // do not show meetings that have not been booked yet
      if (userType !== UserTypes.ADMIN) {
        if (!meeting.endTime && !meeting.startTime) {
          return false;
        }
      }
      // do not show meetings that have end date in the past.
      if (userType !== UserTypes.ADMIN) {
        return new Date(meeting.endTime).getTime() > new Date().getTime();
      }
      return true;
    });
    return filteredMeetings;
  }
}

// This belongs here because it is not going to be used as type anywhere.
export enum MeetingSourceEventTypeSlugPrefix {
  MARKETPLACE_MEETING = 'generalMeeting',
  COMPLIANCE_CONSULTATION = 'complianceConsultation',
  REVIEW_COMPLIANCE_CALENDAR = 'reviewComplianceCalendar',
}
